const Success = () => {
    return (
        <div>
            <h1>Thank you for joining us!</h1>
            <h2>You shall recieve a confirmation email shortly</h2>
        </div>
    )
};

export default Success;